import { DeliveryMode } from "api/resources/learningItems/types"

const pgctl1Videos = [
  "learning-theories-and-teaching-strategies",
  "child-development-learning-styles-and-learning-taxonomies",
  "assessment-and-evaluation-techniques",
  "ethics-and-values",
  "lesson-planning",
  "management-of-class-dynamics",
  "providing-feedback",
  "questioning-skills-and-techniques",
  "reflective-teaching",
  "using-technology-for-teaching-and-learning",
]

const pgctlStarterAndProfessionalVideos = [
  "learning-theories-and-teaching-strategies",
  "child-development-learning-styles-and-learning-taxonomies",
  "lesson-planning",
  "management-of-class-dynamics",
  "using-technology-for-teaching-and-learning",
  "assessment-and-evaluation-techniques",
  "questioning-skills-and-techniques",
  "ethics-and-values",
  "providing-feedback",
  "reflective-teaching",
]

const executiveVideos = [
  "learning-theories-and-teaching-strategies",
  "child-development-learning-styles-and-learning-taxonomies",
  "lesson-planning",
  "management-of-class-dynamics",
  "using-technology-for-teaching-and-learning",
  "assessment-and-evaluation-techniques",
  "questioning-skills-and-techniques",
  "ethics-and-values",
  "providing-feedback",
  "reflective-teaching",
]

export const getAssignmentTutorialVideoUrl = ({
  deliveryMode,
  isNewDeliveryMode,
  courseSlug,
}: {
  deliveryMode?: DeliveryMode | null
  isNewDeliveryMode: boolean
  courseSlug: string
}) => {
  if (deliveryMode === DeliveryMode.EXECUTIVE) {
    if (executiveVideos.includes(courseSlug)) {
      return `https://assets.suraasa.com/lms/pgctl-skill-evidence-how-to-videos/2.0/executive/${courseSlug}.mp4`
    }
  }

  if (isNewDeliveryMode) {
    if (pgctlStarterAndProfessionalVideos.includes(courseSlug)) {
      return `https://assets.suraasa.com/lms/pgctl-skill-evidence-how-to-videos/2.0/${courseSlug}.mp4`
    }
  }

  if (!isNewDeliveryMode) {
    if (pgctl1Videos.includes(courseSlug)) {
      return `https://assets.suraasa.com/lms/pgctl-skill-evidence-how-to-videos/${courseSlug}.mp4`
    }
  }

  return null
}
